import { useMutation } from "react-query";
import { replaceThumbnailWithUpload } from "../query-functions";

/**
 * Hook for replacing an event thumbnail with direct upload
 * @returns {Object} React Query mutation object
 */
export const useReplaceThumbnailWithUpload = () => {
    return useMutation(replaceThumbnailWithUpload);
};